import React from 'react';
import {Divider, Paper} from "convertupleads-theme";
import PageTitleBox from "../../../common/PageTitleBox";
import BasicList from "./ListComponents/BasicList";
import BasicListSelected from "./ListComponents/BasicListSelected";
import BasicListWithIcon from "./ListComponents/BasicListWithIcon";
import ListWithSecondaryText from "./ListComponents/ListWithSecondaryText";
import BasicListDisabled from "./ListComponents/BasicListDisabled";
import ListItemIconCheckbox from "./ListComponents/ListItemIconCheckbox";
import ListItemStartEndICon from "./ListComponents/ListItemStartEndICon";

const ListPage = () => {
    return (
        <Paper elevation={0}>
            <PageTitleBox
                title={"List"}
                description={"Lists are continuous, vertical indexes of text or images."}
            />
            <Divider light />
            <BasicList/>
            <BasicListDisabled/>
            <BasicListWithIcon/>
            <BasicListSelected/>
            <ListWithSecondaryText/>
            <ListItemIconCheckbox/>
            <ListItemStartEndICon/>
        </Paper>
    );
};

export default ListPage;